import comprehensivePinyinDict from "./no-tone-pinyin-hanzi-table.json";

const pinyinToHanziMap: Record<string, string[]> =
  comprehensivePinyinDict as Record<string, string[]>;

// Optional prefix cache to avoid recomputation
const prefixCache = new Map<string, string[]>();

export class PinyinService {
  /**
   * Convert Pinyin input to Chinese character candidates
   * @param pinyinInput - The pinyin string entered by user
   * @returns Array of candidate Chinese characters/words
   */
  public static getCandidates(pinyinInput: string): string[] {
    if (!pinyinInput.trim()) {
      return [];
    }

    const normalizedInput = pinyinInput.toLowerCase().trim();

    // Check cache first
    if (prefixCache.has(normalizedInput)) {
      return prefixCache.get(normalizedInput)!;
    }

    const candidates: string[] = [];
    const seenTexts = new Set<string>(); // For deduplication

    // First, try exact matches for multi-character words
    const exactMatch = pinyinToHanziMap[normalizedInput];
    if (exactMatch) {
      exactMatch.forEach((text, index) => {
        if (!seenTexts.has(text)) {
          seenTexts.add(text);
          candidates.push(text);
        }
      });
    }

    // Cache the result
    prefixCache.set(normalizedInput, candidates);

    return candidates;
  }
}
